import { Button } from "antd";

export const BrokerDetailsScreen = () => {
    return (
        <>
            <h1>Broker Details Screen</h1>
            <Button>Hello</Button>
        </>
    );
}